import React from "react";

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox as MuiCheckbox,
} from "@material-ui/core";

import Base from "./Base";

export default function Checkbox(props) {
  const field = ({ error, label, helperText, value, ...rest }) => {
    const checkbox = <MuiCheckbox checked={value || false} {...rest} />;

    return (
      <FormControl error={!!error}>
        <FormControlLabel control={checkbox} label={label} />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  };

  return <Base as={field} {...props} />;
}
